export default __webpack_public_path__ + "images/oralHealthCoaching.5438ebef721c1f08631ba40773801a39.svg";